import { useCallback, useMemo } from "react";
import type { OwnCreatedDataResponse } from "../types/dashboard-data.types";
import { getDashboardSetupView, type DashboardSetupView } from "../utils/dashboardViewModels";
import { useOwnCreatedData } from "./useOwnCreatedData";

export interface DashboardOwnCreated {
  ownCreatedData: OwnCreatedDataResponse | null;
  ownCreatedSetup: DashboardSetupView | null;
  loading: boolean;
  refreshing: boolean;
  error: string | null;
  retry: () => Promise<void>;
}

export const useDashboardOwnCreated = (): DashboardOwnCreated => {
  const ownCreated = useOwnCreatedData();

  const { refetch: refetchOwnCreated } = ownCreated;

  const ownCreatedSetup = useMemo(() => getDashboardSetupView(ownCreated.data), [ownCreated.data]);

  const retry = useCallback(async () => {
    await refetchOwnCreated();
  }, [refetchOwnCreated]);

  return {
    ownCreatedData: ownCreated.data,
    ownCreatedSetup,
    loading: ownCreated.isLoading,
    refreshing: ownCreated.isRefreshing,
    error: ownCreated.error,
    retry,
  };
};
